import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { PaginationDto, ResponsePackage } from '../models/util.model';
import { EditMvPole, MvPoleDetails, MvPoleStats } from '../models/mv-pole.model';
import { Observable } from 'rxjs';
import { ImageType } from '../models/image.model';
import { AssetStatusEnum } from '../models/assetStatus.model';

@Injectable({
  providedIn: 'root'
})
export class MvPoleService {

  private pathApi: string;
  constructor(private http: HttpClient, private config: AppConfig) {
    this.pathApi = this.config.setting['pathApi'] + 'mvPole/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getById(id: number) {
    return this.http.get<ResponsePackage<EditMvPole>>(
      `${this.pathApi}getById?id=${id}`,
      { headers: this.headers, observe: 'response' }
    );
  }

  getAll(obj: any) {
    return this.http.post<ResponsePackage<PaginationDto<MvPoleDetails>>>(
      `${this.pathApi}getAll`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }

  getStats(obj: any){
    return this.http.post<ResponsePackage<MvPoleStats>>(
      `${this.pathApi}getStats`,
      obj,
      { headers: this.headers, observe: 'response'}
    );
  }

  download(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}downloadFile`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  approveMvPole(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}approveMvPole`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  rejectMvPole(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}rejectMvPole`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  addOrUpdateMvPole(obj: any) {
    return this.http.post<ResponsePackage<string>>(
      `${this.pathApi}addOrUpdate`,
      obj,
      { headers: this.headers, observe: 'response' }
    );
  }

  uploadPicture(obj: any, image: File) {
    let formData: FormData = new FormData();
    formData.append('entityId', obj.poleId);
    formData.append('imageType', obj.imageType);
    formData.append('image', image, image.name);
    formData.append('guid', obj.guid);
    formData.append('url', obj.url);
    formData.append('imageId', obj.imageId);


    return this.http.post<ResponsePackage<Image>>(
      `${this.pathApi}uploadPicture`,
      formData,
      { observe: 'response' }
    );
  }

  auditMvPole(id: number): Observable<any> {
    return this.http.post(`${this.pathApi}auditMvPole/${id}`, id, {
      headers: this.headers,
      observe: 'response',
    });
  }

  recall(id: number) {
    return this.http.get<ResponsePackage<any>>(`${this.pathApi}recall/${id}`, {
      headers: this.headers,
      observe: 'response',
    });
  }

  assignPole(
    mvPoleId: number,
    userId: number,
    assetStatus: AssetStatusEnum,
    isFromRejection: boolean
  ) {
    const obj = {
      entityId: mvPoleId,
      userId: userId,
      assetStatus: assetStatus,
      isFromRejection: isFromRejection,
    };
    return this.http.post<ResponsePackage<string>>(
      `${this.pathApi}assignMvPole`,
      obj,
      { observe: 'response' }
    );
  }
}

export class Image {
  imageType: ImageType;
  url: string;

  constructor(data?: any) {
    this.url = data?.url ?? '';
    this.imageType = data?.imageType;
  }
}